import { Component, Inject, inject } from '@angular/core';
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
} from '@angular/material/snack-bar';
import { IconService } from '../../_core/services/icon.service';

@Component({
  selector: 'app-error-toast',
  templateUrl: './error-toast.component.html',
  styleUrls: ['./error-toast.component.scss'],
})
export class ErrorToastComponent {
  snackBarRef = inject(MatSnackBarRef);
  iconService = inject(IconService);
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string; action: string }
  ) {
    this.iconService.getIcons(['DECLINA'], 'pratica-states');
  }
}
